export function isMobile() {
	return !!window['isMobile' as any];
}